// ================================================================================================
import { PureComponent, CSSProperties, ReactElement, MouseEventHandler, Children } from 'react';
import "./PrimitiveCss.less";
import { Props } from '@Utils/ReactProps';
// ================================================================================================
interface FloatingActionButtonProps extends Props<FloatingActionButton> {
    diameter: number;
    backgroundColor: string;
    iconColor?: string;
    onClick?: MouseEventHandler<any>;
    onMouseDown?: MouseEventHandler<any>;
    style?: CSSProperties;
}
// -------------------------------------------------------------------------------------------------------
export class FloatingActionButton extends PureComponent<FloatingActionButtonProps> {
    constructor(props: FloatingActionButtonProps) {
        super(props);
    }
    render() {
        let iconPadding = Math.floor(this.props.diameter * 0.3 / 2);
        return <div
            style={{
                width: this.props.diameter,
                height: this.props.diameter,
                backgroundColor: this.props.backgroundColor,
                fontSize: Math.floor(this.props.diameter * 5 / 7) + "px",
                lineHeight: this.props.diameter + "px",
                ...this.props.style
            }}
            className="yodiwo-floating-action-button"
            onClick={this.props.onClick}
            onMouseDown={this.props.onMouseDown}>
            {Children.map(this.props.children, (child: ReactElement<any>, i) => <child.type
                {...child.props}
                style={{
                    width: this.props.diameter,
                    height: this.props.diameter,
                    padding: iconPadding,
                    color: this.props.iconColor
                }}
            />)}
        </div>;
    }
}
// -------------------------------------------------------------------------------------------------------